module.exports = __webpack_public_path__ + "img/recommend-zx-title.8e281e25.png";